import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { publicConfig } from "@/config/public-config";

import enExample from "./en/_example.json";
import enAdmin from "./en/admin.json";
import enAudit from "./en/audit.json";
import enAuth from "./en/auth.json";
import enCampaign from "./en/campaign.json";
import enCommon from "./en/common.json";
import enDashboard from "./en/dashboard.json";
import enExportOrders from "./en/export_orders.json";
import enInboundReport from "./en/inbound_report.json";
import enInventory from "./en/inventory.json";
import enInventoryDiff from "./en/inventory_diff.json";
import enManualReview from "./en/manual_review.json";
import enMarketplaceConnections from "./en/marketplace_connections.json";
import enNav from "./en/nav.json";
import enNotifications from "./en/notifications.json";
import enOrders from "./en/orders.json";
import enPromotion from "./en/promotion.json";
import enPromotionReport from "./en/promotion_report.json";
import enRevenueReport from "./en/revenue_report.json";
import enRole from "./en/role.json";
import enStatus from "./en/status.json";
import enUserStatus from "./en/user_status.json";
import enUsers from "./en/users.json";
import thExample from "./th/_example.json";
import thAdmin from "./th/admin.json";
import thAudit from "./th/audit.json";
import thAuth from "./th/auth.json";
import thCampaign from "./th/campaign.json";
import thCommon from "./th/common.json";
import thDashboard from "./th/dashboard.json";
import thExportOrders from "./th/export_orders.json";
import thInboundReport from "./th/inbound_report.json";
import thInventory from "./th/inventory.json";
import thInventoryDiff from "./th/inventory_diff.json";
import thManualReview from "./th/manual_review.json";
import thMarketplaceConnections from "./th/marketplace_connections.json";
import thNav from "./th/nav.json";
import thNotifications from "./th/notifications.json";
import thOrders from "./th/orders.json";
import thPromotion from "./th/promotion.json";
import thPromotionReport from "./th/promotion_report.json";
import thRevenueReport from "./th/revenue_report.json";
import thRole from "./th/role.json";
import thStatus from "./th/status.json";
import thUserStatus from "./th/user_status.json";
import thUsers from "./th/users.json";

const PSEUDO_LOCALE_ENABLED = publicConfig.PSEUDO_LOCALE === "true";

const baseResources = {
  en: {
    common: enCommon,
    nav: enNav,
    inventory: enInventory,
    inventory_diff: enInventoryDiff,
    orders: enOrders,
    dashboard: enDashboard,
    campaign: enCampaign,
    promotion: enPromotion,
    promotion_report: enPromotionReport,
    export_orders: enExportOrders,
    inbound_report: enInboundReport,
    revenue_report: enRevenueReport,
    auth: enAuth,
    admin: enAdmin,
    audit: enAudit,
    role: enRole,
    user_status: enUserStatus,
    users: enUsers,
    status: enStatus,
    notifications: enNotifications,
    manual_review: enManualReview,
    marketplace_connections: enMarketplaceConnections,
    _example: enExample,
  },
  th: {
    common: thCommon,
    nav: thNav,
    inventory: thInventory,
    inventory_diff: thInventoryDiff,
    orders: thOrders,
    dashboard: thDashboard,
    campaign: thCampaign,
    promotion: thPromotion,
    promotion_report: thPromotionReport,
    export_orders: thExportOrders,
    inbound_report: thInboundReport,
    revenue_report: thRevenueReport,
    auth: thAuth,
    admin: thAdmin,
    audit: thAudit,
    role: thRole,
    user_status: thUserStatus,
    users: thUsers,
    status: thStatus,
    notifications: thNotifications,
    manual_review: thManualReview,
    marketplace_connections: thMarketplaceConnections,
    _example: thExample,
  },
} as const;

// Pseudo-locale bundle is gitignored (Task 11 creates it). Conditionally
// register only when PUBLIC_PSEUDO_LOCALE=true. We can't statically import a
// file that may not exist; use a typed Record so TS doesn't trip.
const resources: Record<string, unknown> = { ...baseResources };

if (PSEUDO_LOCALE_ENABLED) {
  console.warn(
    "[i18n] PUBLIC_PSEUDO_LOCALE=true: en-XA registration uses async import; ensure your bundler resolves ./en-XA/_bundle.json or run `pnpm gen:pseudo-locale`.",
  );
}

export { resources };
export type AppNamespace = keyof (typeof baseResources)["en"];

// eslint-disable-next-line import/no-named-as-default-member
void i18n.use(initReactI18next).init({
  resources: resources as never,
  lng: publicConfig.DEFAULT_LOCALE,
  fallbackLng: "en",
  ns: [
    "common",
    "nav",
    "inventory",
    "inventory_diff",
    "orders",
    "dashboard",
    "campaign",
    "promotion",
    "promotion_report",
    "export_orders",
    "inbound_report",
    "revenue_report",
    "auth",
    "admin",
    "audit",
    "role",
    "user_status",
    "users",
    "status",
    "notifications",
    "manual_review",
    "marketplace_connections",
    "_example",
  ],
  defaultNS: "common",
  interpolation: {
    escapeValue: false,
    defaultVariables: { appName: "Atlas OMS" },
  },
  returnNull: false,
});

export default i18n;
